import styled from '@emotion/styled'
import { Flex } from 'shared/ui'

export default styled(Flex)`
  align-items: center;
  margin-left: -4px;
  color: ${props => props.theme.color.monochrome.mediumDark};
  & > * {
    margin-right: ${props => props.theme.spacing['7']};
    :last-child {
      margin-right: 0px;
    }
  }
`
